export enum ExplorerType {
  Directory = 'directory',
  File = 'file',
  Dataset = 'dataset',
}
